import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Box from '../box/box.jsx';
import Label from '../forms/label.jsx';
import Input from '../forms/input.jsx';
import BufferedInputHOC from '../forms/buffered-input-hoc.jsx';
import DirectionPicker from '../../containers/direction-picker.jsx';

import {injectIntl, FormattedMessage} from 'react-intl';

import {STAGE_DISPLAY_SIZES} from '../../lib/layout-constants.js';
import styles from './sprite-info.css';

import xIcon from './icon--x.svg';
import yIcon from './icon--y.svg';
import showIcon from './icon--show.svg';
import hideIcon from './icon--hide.svg';
import zoomIcon from './icon--zoom.svg';
import directionIcon from './icon--direction.svg';

const BufferedInput = BufferedInputHOC(Input);

class SpriteInfo extends React.Component {
    shouldComponentUpdate (nextProps) {
        return (
            this.props.rotationStyle !== nextProps.rotationStyle ||
            this.props.direction !== nextProps.direction ||
            this.props.disabled !== nextProps.disabled ||
            this.props.name !== nextProps.name ||
            this.props.size !== nextProps.size ||
            this.props.stageSize !== nextProps.stageSize ||
            this.props.visible !== nextProps.visible ||
            this.props.x !== nextProps.x ||
            this.props.y !== nextProps.y
        );
    }
    render () {
        const sizeLabel = (
            <FormattedMessage
                defaultMessage="Size"
                description="Sprite info size label"
                id="gui.SpriteInfo.size"
            />
        );
        // const directionLabel = (
        //     <FormattedMessage
        //         defaultMessage="Direction"
        //         description="Sprite info direction label"
        //         id="gui.SpriteInfo.direction"
        //     />
        // );

        const spriteName = (
            <span className={styles.spriteName}>{this.props.name}</span>
        );

        const xPosition = (
            <div className={styles.group}>
                   
                <div className={styles.iconWrapper}>
                    <img
                        aria-hidden="true"
                        className={classNames(styles.xIcon, styles.icon)}
                        src={xIcon}
                    />
                </div>
                <Label text="x">
                    <BufferedInput
                        small
                        disabled={this.props.disabled}
                        placeholder="x"
                        tabIndex="0"
                        type="text"
                        value={this.props.disabled ? '' : this.props.x}
                        onSubmit={this.props.onChangeX}
                    />
                </Label>
            </div>
        );

        const yPosition = (
            <div className={styles.group}>
                <div className={styles.iconWrapper}>
                    <img
                        aria-hidden="true"
                        className={classNames(styles.yIcon, styles.icon)}
                        src={yIcon}
                    />
                </div>
                <Label text="y">
                    <BufferedInput
                        small
                        disabled={this.props.disabled}
                        placeholder="y"
                        tabIndex="0"
                        type="text"
                        value={this.props.disabled ? '' : this.props.y}
                        onSubmit={this.props.onChangeY}
                    />
                </Label>
            </div>
        );

        return (
            <Box className={styles.spriteInfo}>
                <div className={classNames(styles.row, styles.rowPrimary)}>
                    <div className={classNames(styles.group, styles.largerInput)}>
                        {spriteName}
                        
                    </div>
                    
                    <div className={classNames(styles.group)}>
                        <div className={styles.radioWrapper}>
                            {this.props.visible ?
                                (<div
                                    className={classNames(
                                        styles.iconWrapper,
                                        {[styles.disabled]: this.props.disabled}
                                    )}
                                    tabIndex="0"
                                    onClick={this.props.onClickNotVisible}
                                    onKeyPress={this.props.onPressNotVisible}
                                >
                                    <img
                                        className={classNames(styles.icon, styles.eyeIcon)}
                                        src={showIcon}
                                    />
                                </div>) :

                                (<div
                                    className={classNames(
                                        styles.iconWrapper
                                    )}
                                    tabIndex="0"
                                    onClick={this.props.onClickVisible}
                                    onKeyPress={this.props.onPressVisible}
                                >
                                    <img
                                        className={classNames(styles.icon, styles.eyeIcon)}
                                        src={hideIcon}
                                    />
                                </div>)


                            }
                        </div>
                    
                    </div>
                   
                    {xPosition}
                    {yPosition}
                
                    <div className={classNames(styles.group)}>
                        <div className={styles.iconWrapper}>
                            <img
                                className={styles.iconSmall}
                                src={zoomIcon}
                            />
                        </div>
                        <Label
                            secondary
                            text={sizeLabel}
                        >
                            <BufferedInput
                                small
                                disabled={this.props.disabled}
                                label={sizeLabel}
                                tabIndex="0"
                                type="text"
                                value={this.props.disabled ? '' : this.props.size}
                                onSubmit={this.props.onChangeSize}
                            />
                        </Label>
                    </div>
                    <div className={classNames(styles.group, styles.directionGroup)}>
                        <div className={styles.iconWrapper}>
                            <img
                                className={styles.iconSmall}
                                src={directionIcon}
                            />
                        </div>
                        <DirectionPicker
                            direction={this.props.direction}
                            disabled={this.props.disabled}
                            rotationStyle={this.props.rotationStyle}
                            onChangeDirection={this.props.onChangeDirection}
                            onChangeRotationStyle={this.props.onChangeSpriteRotationStyle}
                        />
                    </div>
                </div>
            </Box>
        );
    }
}

SpriteInfo.propTypes = {
    direction: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    disabled: PropTypes.bool,
    // intl: intlShape,
    name: PropTypes.string,
    onChangeDirection: PropTypes.func,
    // onChangeName: PropTypes.func,
    onChangeSize: PropTypes.func,
    onChangeSpriteRotationStyle: PropTypes.func,
    onChangeX: PropTypes.func,
    onChangeY: PropTypes.func,
    onClickNotVisible: PropTypes.func,
    onClickVisible: PropTypes.func,
    onPressNotVisible: PropTypes.func,
    onPressVisible: PropTypes.func,
    rotationStyle: PropTypes.string,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    visible: PropTypes.bool,
    x: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    y: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default injectIntl(SpriteInfo);
